import { styled } from 'stitches.config'

export const TableWrapper = styled('table', {
  paddingBottom: '$2',
  borderCollapse: 'collapse',

  '& th': {
    fontSize: '$headline',
    lineHeight: '$headline',
    fontWeight: '$medium',
    letterSpacing: '$body',
    verticalAlign: 'bottom',
    paddingBottom: '6px',
  },
  '& thead': {
    borderBottom: '1px solid $accent-black',
  },
  '& tbody tr:first-child td': {
    paddingTop: '12px',
  },
  '& tbody': {
    paddingBottom: '4px',
  },
  '& th:nth-child(1)': {
    width: '40%',
  },
  '& th:nth-child(2)': {
    width: '60%',
  },
  '& td': {
    fontSize: '$body',
    lineHeight: '$body',
    letterSpacing: '$body',
    padding: '4px',
  },
})

export const TableRoot = styled('div', {
  background: '$tertiary-200',
  paddingBottom: '16px',
  padding: '32px 16px 16px',
  marginTop: '$2',
  maxWidth: '576px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  '@bp2': {
    padding: '40px 40px 16px',
  },
})

export const AdditionalInfo = styled('div', {
  width: '100%',
  textAlign: 'right',
})
